// extracted by mini-css-extract-plugin
export default {"HeroInfo":"HeroInfo_HeroInfo__Glxms","Heading":"HeroInfo_Heading__AOoPH","Text":"HeroInfo_Text__7CMrx","swing-in":"HeroInfo_swing-in__QvyxF"};